import React from "react";
import "./ContactPage.css";
import ContactItem from "./../../Component/ContactItem/ContactItem";
import phone from "../../img/phone.svg";
import email from "../../img/emailme.svg";
import location from "../../img/location.svg";
import Tittle from "../../Component/Tittle/Tittle";

function ContactPage() {
  return (
    <div className="ContactPage-main">
      <div className="title">
        <Tittle title={"Contact"} span={"Contact"} />
      </div>
      <div className="ContactPage">
        <div className="map-section">
          <iframe
            src="https://www.youtube.com/embed/uXWycyeTeCs"
            width={1000}
            height={500}
            sandbox="allow-scripts allow-modal"
            loading="lazy"
            title="Custom title"
          ></iframe>
        </div>
        <div className="contact-section">
          <ContactItem
            icon={phone}
            text1={"97987897897987"}
            text2={"97987897897987"}
            title={"phone"}
          />
          <ContactItem
            icon={email}
            text1={"97987897897987"}
            text2={"97987897897987"}
            title={"email"}
          />
          <ContactItem
            icon={location}
            text1={"97987897897987"}
            text2={"97987897897987"}
            title={"loaction"}
          />
        </div>
      </div>
    </div>
  );
}

export default ContactPage;
